import React from "react";
import cx from "classnames";
import {
  SILO_TEMPLATE_DICON,
  ROOM_TEMPLATE_DICON,
  AUGMENTED_REALITY_DICON,
  VIDEO_DICON,
  VIGNETTE_DICON,
  WEB_VIEWER_DICON,
  CONFIGURATOR_DICON,
  LIFESTYLE_TEMPLATE_DICON,
} from "../constants/assetConstants";
import {
  SILO_TEMPLATE_BG,
  ROOM_TEMPLATE_BG,
  AUGMENTED_REALITY_BG,
  VIDEO_BG,
  VIGNETTE_BG,
  WEB_VIEWER_BG,
  CONFIGURATOR_BG,
  LIFESTYLE_TEMPLATE_BG,
} from "../constants/assetConstants";
import { Link } from "react-router-dom";
import { ROOM_OPTIONS, URL_SLUG__ROOM_TYPE_MAP } from "../constants/filters";
import { addUpdateParamsInSequence } from "../redux/slicers/filters/filterSlicer";
import { getParamsFromFilterBy } from "../helpers/urlHelper";
import { dispatcher } from "../helpers/projectHelper";
import NEW_SILO_TEMPLATE_BG from "../assets/images/SiloTemplate.png";
import NEW_VIGNETTE_TEMPLATE_BG from "../assets/images/VignetteTemplate.png";
import NEW_LIFESYTLE_TEMPLATE_BG from "../assets/images/LifestyleTemplate.png";
import NEW_VIDEO_TEMPLATE_BG from "../assets/images/VideoTemplate.png";
import NEW_SILO_TEMPLATE_ICON from "../assets/images/SiloIconTemplate.png";
import NEW_VIGNETTE_TEMPLATE_ICON from "../assets/images/VignetteIconTemplate.png";
import NEW_LIFESYTLE_TEMPLATE_ICON from "../assets/images/LifestyleIconTemplate.png";
import NEW_VIDEO_TEMPLATE_ICON from "../assets/images/VideoIconTemplate.png";
import { setRequestVideoDialogOpen } from "../redux/slicers/admin/curatorSlicer";
import { icons } from "../assets";
import { Mixpanel } from "./Mixpanel";
const {
  LifestyleIconTemplate,
  SiloIconTemplate,
  VignetteIconTemplate,
  VideoIconTemplate,
} = icons;

export default function DesignTemplates(props) {

  const Content = {
    ["Room Template"]: "",
    Lifestyle: "Images in life-like environments",
    Silo: "Images against a white background",
    Vignette: "Product-focused imagery",
    ["360 Web Viewer"]: "",
    Video: "Render videos for your products",
    Configurator: "",
    ["Augmented Reality"]: "",
  };

  const Background = {
    ["Room Template"]: ROOM_TEMPLATE_BG,
    Lifestyle: NEW_LIFESYTLE_TEMPLATE_BG,
    Silo: NEW_SILO_TEMPLATE_BG,
    Vignette: NEW_VIGNETTE_TEMPLATE_BG,
    ["360 Web Viewer"]: WEB_VIEWER_BG,
    Video: NEW_VIDEO_TEMPLATE_BG,
    Configurator: CONFIGURATOR_BG,
    ["Augmented Reality"]: AUGMENTED_REALITY_BG,
  };

  const siloTemplateBG = {
    backgroundImage: `url(${NEW_SILO_TEMPLATE_BG})`,
  };
  const roomTemplateBG = {
    backgroundImage: `url(${ROOM_TEMPLATE_BG})`,
  };
  const augmentedRealityBG = {
    backgroundImage: `url(${AUGMENTED_REALITY_BG})`,
  };
  const lifestyleTemplateBG = {
    backgroundImage: `url(${NEW_LIFESYTLE_TEMPLATE_BG})`,
  };
  const videoBG = {
    backgroundImage: `url(${NEW_VIDEO_TEMPLATE_BG})`,
  };
  const vignetteBG = {
    backgroundImage: `url(${NEW_VIGNETTE_TEMPLATE_BG})`,
  };
  const webViewerBG = {
    backgroundImage: `url(${WEB_VIEWER_BG})`,
  };
  const configuratorBG = {
    backgroundImage: `url(${CONFIGURATOR_BG})`,
  };

  const Icons = {
    ["Room Template"]: ROOM_TEMPLATE_DICON,
    Lifestyle: NEW_LIFESYTLE_TEMPLATE_ICON,
    Silo: NEW_SILO_TEMPLATE_ICON,
    Vignette: NEW_VIGNETTE_TEMPLATE_ICON,
    ["360 Web Viewer"]: WEB_VIEWER_DICON,
    Video: NEW_VIDEO_TEMPLATE_ICON,
    Configurator: CONFIGURATOR_DICON,
    ["Augmented Reality"]: AUGMENTED_REALITY_DICON,
  };

  const IconComponent = {
    Lifestyle: LifestyleIconTemplate,
    Silo: SiloIconTemplate,
    Vignette: VignetteIconTemplate,
    Video: VideoIconTemplate,
  };

  return (
    <div
      className={cx(
        {
          center: props.center,
        },
        "designTemplates 2"
      )}
    >
      {ROOM_OPTIONS?.length > 0 ? (
        ROOM_OPTIONS?.map(({ label, value, mx_event }, index) => {
          const roomType = URL_SLUG__ROOM_TYPE_MAP[value];

          const isVideo = label === "Video";
          const Icon = IconComponent[label];

          if (props?.excludeVideo && isVideo) return null;

          return (
            <Link
              to={
                isVideo
                  ? "#"
                  : `/newdesigns/${value}?roomType=${roomType}&filterOrder=filterBy&filterBy=${roomType}`
              }
              key={`templateLink${label}`}
              className={props?.excludeVideo && !isVideo ? "w-33" : ""}
              onClick={() => {
                if (isVideo) {
                  Mixpanel.track( true, mx_event);
                  dispatcher(setRequestVideoDialogOpen(true));
                  return;
                }
                Mixpanel.track( true, mx_event, {
                  Template_type: value,
                });
                dispatcher(
                  addUpdateParamsInSequence({
                    filterBy: getParamsFromFilterBy(
                      { ["value"]: roomType },
                      "room_type"
                    ),
                  })
                );
              }}
            >
              <div
                className={`template silo`}
                style={{ backgroundImage: `url(${Background[label]})` }}
                key={index + 1}
              >
                {/* <img src={Icons[label]} /> */}
                {Icon && <Icon />}
                <div className="template-info">
                  <h5>{label}</h5>
                  <p>{Content[label]}</p>
                </div>
              </div>
            </Link>
          );
        })
      ) : (
        <>
          <div className="template lifestyle 3" style={lifestyleTemplateBG}>
            <img src={SILO_TEMPLATE_DICON} />
            <h5>Lifestyle</h5>
            <p>Images in life-like environments</p>
          </div>
          <div className="template silo" style={siloTemplateBG}>
            <img src={SILO_TEMPLATE_DICON} />
            <h5>Silo</h5>
            <p>Images against a white background</p>
          </div>
          <div className="template vignette" style={vignetteBG}>
            <img src={VIGNETTE_DICON} />
            <h5>Vignette</h5>
            <p>Product-focused imagery</p>
          </div>
          <div className="template droom" style={roomTemplateBG}>
            <img src={ROOM_TEMPLATE_DICON} />
            <h5>Room Template</h5>
            <p>Explaination goes here</p>
          </div>
          <div
            className="template augmented-reality"
            style={augmentedRealityBG}
          >
            <img src={AUGMENTED_REALITY_DICON} />
            <h5>Augmented Reality</h5>
            <p>Explaination goes here</p>
          </div>
          <div className="template video" style={videoBG}>
            <img src={VIDEO_DICON} />
            <h5>Video</h5>
            <p>Explaination goes here</p>
          </div>
          <div className="template web-viewer" style={webViewerBG}>
            <img src={WEB_VIEWER_DICON} />
            <h5>360 Web Viewer</h5>
            <p>Explaination goes here</p>
          </div>
          <div className="template configurator" style={configuratorBG}>
            <img src={CONFIGURATOR_DICON} />
            <h5>Configurator</h5>
            <p>Explaination goes here</p>
          </div>
        </>
      )}
    </div>
  );
}
